/**
 * NOTE: These values are stored in .env files IN APP WORKSPACES, not in this package
 */
import env from './env/index.js';
import isTest from './isTest/index.js';
export default {
    // Priority: Unprefixed (backend/CI) > VITE_* (frontend Vite) > REACT_APP_* (legacy)
    apiBaseUrl: process.env.API_BASE_URL || process.env.VITE_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || '',
    appEnv: env.get('APP_ENV'),
    assetsBaseUrl: process.env.ASSETS_BASE_URL || process.env.VITE_ASSETS_BASE_URL || process.env.REACT_APP_ASSETS_BASE_URL || '',
    isDebug: env.get('APP_DEBUG', 'bool', false),
    marketingSiteBaseUrl: process.env.MARKETING_SITE_BASE_URL || process.env.VITE_MARKETING_SITE_BASE_URL || process.env.REACT_APP_MARKETING_SITE_BASE_URL || 'commonsenseprivacy.net',
    newRelic: {
        isEnabled: !isTest && env.get('NEW_RELIC_ENABLED', 'bool', false),
        licenseKey: env.get('NEW_RELIC_LICENSE_KEY'),
        accountId: env.get('NEW_RELIC_ACCOUNT_ID'),
        applicationId: env.get('NEW_RELIC_APPLICATION_ID'),
        trustKey: env.get('NEW_RELIC_TRUST_KEY'),
    },
    recaptchaV3SiteKey: env.get('RECAPTCHA_V3_SITE_KEY'),
    sentryDsn: env.get('SENTRY_DSN'),
    sentryEnabled: !isTest && env.get('SENTRY_ENABLED', 'bool', false),
    webAppBaseUrl: process.env.WEB_APP_BASE_URL || process.env.VITE_WEB_APP_BASE_URL || process.env.REACT_APP_WEB_APP_BASE_URL || '',
    stripe: {
        secretKey: process.env.STRIPE_SECRET_KEY,
        publishableKey: env.get('STRIPE_PUBLISHABLE_KEY'),
        webhookSecret: process.env.STRIPE_WEBHOOK_SECRET,
        defaultProductDashboardId: process.env.STRIPE_DEFAULT_PRODUCT_DASHBOARD,
    },
    mockApi: env.get('MOCK_API'),
};
//# sourceMappingURL=config.js.map